<template>
  <div v-if="!user">
    <v-btn @click="$router.push(routeName === 'Register' ? '/login' : '/register')" light color="primary">
    {{ routeName === 'Register' ? 'Login' : 'Register new account' }}
    </v-btn>
  </div>
</template>

<script>
import { /*mapGetters,*/ mapState } from 'vuex';

export default {
  name: 'ToolbarAuthButtons',
  data() {
    return {
      debug: false
    }
  },
  props: {
  },
  computed: {
    ...mapState('auth', {
      user: state => state.user
    }),
    // routeParams() {
    //   if (this.debug) console.log(this.$options.name+'.computed *** routeParams $route',this.$route,'this.$router:',this.$router);
    //   return this.$route.params;
    // },
    // routeObj() {
    //   if (this.debug) console.log(this.$options.name+'.computed *** routeObj $route',this.$route,'this.$router:',this.$router);
    //   return this.$route;
    // },
    routeName() {
      // if (this.debug) console.log(this.$options.name+'.computed *** routeName $route',this.$route,'this.$router:',this.$router);
      return this.$route.name;
    }
  },
  watch: {
    // '$route'(to, from) {
    //   console.log(this.$options.name+'.watch *** route to',to,'from:',from);
    // }
  },
  beforeRouteEnter(to, from, next) {
    // called before the route that renders this component is confirmed.
    // does NOT have access to `this` component instance,
    // because it has not been created yet when this guard is called!
    console.log('ToolbarAuthButtons.beforeRouteEnter *** route to',to,'from:',from);
    next();
  },
  beforeRouteUpdate(to, from, next) {
    // called when the route that renders this component has changed,
    // but this component is reused in the new route.
    // For example, for a route with dynamic params `/foo/:id`, when we
    // navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
    // will be reused, and this hook will be called when that happens.
    // has access to `this` component instance.
    console.log('ToolbarAuthButtons.beforeRouteUpdate *** route to',to,'from:',from);
    next();
  },
  beforeRouteLeave(to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    console.log('ToolbarAuthButtons.beforeRouteLeave *** route to',to,'from:',from);
    next();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>